// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminDashboard_mapsContainer__nKLpJ path {
  fill: #DFDEDE;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/super-admin/modules/super-admin-dashboard/SuperAdminDashboard.module.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;AADJ","sourcesContent":["\n.mapsContainer{\n  path {\n    fill: #DFDEDE;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapsContainer": `SuperAdminDashboard_mapsContainer__nKLpJ`
};
export default ___CSS_LOADER_EXPORT___;
